/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import Alert from 'common/components/Alert';

import { useAppDispatch, useAppSelector } from 'common/stores/redux/hooks';
import { setLoading } from 'common/stores/redux/Authentication';
import ResetPassword from './ResetPassword';

import { resetPassword as AuthServiceResetPassword } from '../../services/AuthService';

/**
 * Login
 *
 */
const ResetPasswordContainer = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const loading = useAppSelector(state => state.authentication.loading);

    const params = new URLSearchParams(location.search);
    const accessToken = params.get('access_token');

    const [password, setPassword] = useState('');
    const [confirmationPassword, setConfirmationPassword] = useState('');
    const [passwordSuccessfullyReset, setPasswordSuccessfullyReset] =
        useState(false);
    const [error, setError] = useState('');

    return (
        <div>
            <ResetPassword
                loading={loading}
                password={password}
                confirmationPassword={confirmationPassword}
                error={error}
                passwordSuccessfullyReset={passwordSuccessfullyReset}
                handlePasswordChange={password => setPassword(password)}
                handleConfirmationPasswordChange={password =>
                    setConfirmationPassword(password)
                }
                handleResetPassword={e => handleResetPassword(e)}
                handleGoToAccountLogin={() => navigate('/login')}
            />
        </div>
    );

    function handleResetPassword(e) {
        e.preventDefault();

        if (!password && !confirmationPassword) {
            return setError('No password specified.');
        }

        if (password !== confirmationPassword) {
            return setError('Passwords do not match.');
        }
        setError(null);

        const resetPasswordData = {
            password,
            confirmationPassword,
            token: accessToken,
        };

        dispatch(setLoading(true));

        return AuthServiceResetPassword(resetPasswordData)
            .then(response => {
                setPasswordSuccessfullyReset(true);
                return response;
            })
            .catch(errObject => {
                setError(errObject.message);
                if (errObject.message === 'Invalid token') {
                    Alert.error(
                        'There was an error processing the request, please contact support@motili.com if you need assistance logging into your account.'
                    );
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
    }
};

export default ResetPasswordContainer;
